import { Button, Form, FormItemProps, Input, Modal } from "antd";
import classes from "./ModalAddContactInfo.module.css";
import { IModalAddContactInfoProps } from "../../../../interfaces/props/AdminAgentInfo/IModalAddContactInfoProps";

export const ModalAddContactInfo = ({
  modalProps = {},
  cancelButtonProps = {},
  submitButtonProps = {},
  formProps = {},
}: IModalAddContactInfoProps) => {
  const {
    footer: modalFooter = false,
    width: modalWidth = 700,
    open: modalOpen = false,
    ...restModalProps
  } = modalProps;

  const {
    size: cancelButtonSize = "middle",
    className: cancelButtonClass = "",
    ...restCancelButtonProps
  } = cancelButtonProps;

  const {
    size: submitButtonSize = "middle",
    type: submitButtonType = "primary",
    className: submitButtonClass = "",
    children: submitButtonChildren = "Добавить",
    ...restSubmitButtonProps
  } = submitButtonProps;

  const {
    layout: formLayout = "vertical",
    className: formClassName = "",
    ...restFormProps
  } = formProps;

  const modalAddContactInfoFields: FormItemProps[] = [
    {
      label: <span>Фамилия</span>,
      children: <Input size="large" placeholder="Введите фамилию" />,
      rules: [],
      className: classes.formItem,
      name: "surname",
    },
    {
      label: <span>Имя</span>,
      children: <Input size="large" placeholder="Введите имя" />,
      rules: [],
      className: classes.formItem,
      name: "name",
    },
    {
      label: <span>Отчество</span>,
      children: <Input size="large" placeholder="Введите отчество" />,
      rules: [],
      className: classes.formItem,
      name: "patronymic",
    },
    {
      label: <span>Телефон</span>,
      children: <Input size="large" placeholder="+7 999 999 99 99" />,
      rules: [],
      className: classes.formItem,
      name: "phone_number",
    },
  ];

  return (
    <Modal
      footer={modalFooter}
      open={modalOpen}
      width={modalWidth}
      {...restModalProps}
    >
      <div className={classes.modalTitle}>Добавить контактное лицо</div>

      <Form
        layout={formLayout}
        className={`${classes.modalAddContactInfo} ${formClassName}`}
        {...restFormProps}
      >
        {modalAddContactInfoFields.map((el) => (
          <Form.Item {...el} key={String(el.name)}>
            {el.children}
          </Form.Item>
        ))}

        <div className={classes.modalFooter}>
          <Button
            size={submitButtonSize}
            type={submitButtonType}
            className={submitButtonClass}
            {...restSubmitButtonProps}
          >
            {submitButtonChildren}
          </Button>

          <Button
            size={cancelButtonSize}
            className={`${classes.cancelBtn} ${cancelButtonClass}`}
            {...restCancelButtonProps}
          >
            Отменить
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
